<template>
    <div class="fc-display-contents">
        <component
            :is="element.elementType"
            v-for="(element, index) in elementsNew"
            :key="element.id"
            :pointer="index + 1"
            :index="index"
            v-bind="element"
            @element-updated="elementUpdated"
            @submit-form="submitForm"
        />
    </div>
</template>

<script>
export default {
    name: 'drop-zone-output',

    props: {
        elementsNew: {
            type: Array,
            required: true,
        },
    },

    methods: {
        elementUpdated(updatedElement) {
            this.$emit('element-updated', updatedElement);
        },

        submitForm() {
            this.$emit('submit-form');
        },
    },
};
</script>
